import React, { Component } from 'react';
import { withStyles, Drawer } from '@material-ui/core/';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SidebarTitle from './SidebarTitle'
import clsx from 'clsx'

const styles = theme => ({
    SwipeableDrawer: {
        '& .MuiDrawer-paperAnchorRight': {
            background: '#f8fafc'
        }
    },
    fullList: {
        width: 'auto',
    },
    formContainer: {
        padding: '0 24px',
        backgroundColor: '#F8FAFC',
        height: '100%',
        maxWidth: '480px'
    },
    closeIcon: {
        transform: "scale(0.68)",
        float: "right",
        cursor: "pointer"
    },
    HeaderForm: {
        height: 57,
        padding: '15px 24px 15px 24px',
        borderBottom: '1px solid #E6EDF5',
        backgroundColor: 'white',
        width: '100%'
    },
});

class sideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    handleDrawerOpen = () => {
        this.setState({ open: true });
    }

    handleDrawerClose = () => {
        this.setState({ open: false });
    }
    render() {
        const { classes, className, isCloseOnOutsideClick = true } = this.props;
        return (
            <Drawer
                anchor="right"
                open={this.props.open}
                onClose={
                    () => {
                        if (isCloseOnOutsideClick && this.props.handleDrawerClose) {
                            this.props.handleDrawerClose();
                        }
                    }
                }
                className={clsx(classes.SwipeableDrawer, classes.drawer)}
            >
                <div
                    id='sidebar'
                    tabIndex={-1}
                    className={clsx(className, classes.list)}
                >
                    {this.props.title ?
                        <div className={classes.HeaderForm} >
                            <SidebarTitle
                                title={this.props.title}
                                icon={this.props.icon}
                            />
                            <div className={classes.closeIcon} onClick={this.props.handleDrawerClose}>
                                <FontAwesomeIcon color="#BABABA" icon={['fal', 'times']} size="2x" />
                            </div>
                        </div>
                        : ''}
                    {this.props.children}
                </div>
            </Drawer>
        )
    }
}
export default withStyles(styles)(sideMenu);
